module.exports = __webpack_public_path__ + "img/Economy.15f8cb64.png";